import React from "react";
import { Link } from "react-router-dom";
import "./OurTeam.scss";
import staff_vakho from "../../assets/OurTeam/staff/staff-vakho.png";
import staff_eter from "../../assets/OurTeam/staff/staff-eter.png";
import staff_archil from "../../assets/OurTeam/staff/staff-archil.jpg";
import staff_guranda from "../../assets/OurTeam/staff/staff-guranda-dolidze.png";
import staff_enri from "../../assets/OurTeam/staff/staff-enri-verulidze.jpg";
import staff_tamar from "../../assets/OurTeam/staff/staff-tamar-parchukidze.jpg";
import staff_maia from "../../assets/OurTeam/staff/staff-maia-davitadze.jpg";
import staff_mirian from "../../assets/OurTeam/staff/staff-mirian-oragvelidze.jpg";
import staff_ramaz from "../../assets/OurTeam/staff/staff-ramaz-khmaladze.jpg";
import staff_raul from "../../assets/OurTeam/staff/staff-raul-tsintsadze.jpg";
import staff_saba from "../../assets/OurTeam/staff/staff-saba-gograchadze.png";
import jury_grisha from "../../assets/OurTeam/jury/jury_grisha.png";
import jury_natia from "../../assets/OurTeam/jury/jury_natia.jpg";
import jury_nino from "../../assets/OurTeam/jury/jury_nino.jpg";
import jury_john_shehata from "../../assets/OurTeam/jury/jury_john_shehata.jpg";
import jury_nino_gelovani_2025 from "../../assets/OurTeam/jury/jury_nino_gelovani_2025.jpg";
import jury_elizbar_tsivnaridze from "../../assets/OurTeam/jury/jury_elizbar_tsivnaridze.jpg";
import jury_natalie_stewart_fox from "../../assets/OurTeam/jury/jury_natalie_stewart_fox.jpg";
import { useLanguage } from "../../i18n/LanguageContext";
import { footer, team } from "../../i18n/content";

const staffImgs = [
  staff_vakho,
  staff_eter,
  staff_archil,
  staff_guranda,
  staff_enri,
  staff_tamar,
  staff_maia,
  staff_mirian,
  staff_ramaz,
  staff_raul,
  staff_saba,
];
const juryImgs = [jury_natia, jury_grisha, jury_nino];
const jury2025Imgs = [
  jury_john_shehata,
  jury_nino_gelovani_2025,
  jury_elizbar_tsivnaridze,
  jury_natalie_stewart_fox,
];

const OurTeam = () => {
  const { t } = useLanguage();
  const staff = team.staff.map((person, i) => ({
    img: staffImgs[i],
    name: t(person.name),
    role: t(person.role),
  }));
  const jury = team.jury.map((person, i) => ({
    img: juryImgs[i],
    name: t(person.name),
  }));
  const jury2025 = team.jury2025.map((person, i) => ({
    img: jury2025Imgs[i],
    name: t(person.name),
    role: t(person.role),
  }));

  return (
    <div className="our_team_test_wrapper">
      <header className="lw-page-hero">
        <div className="lw-wrap">
          <div className="lw-eyebrow">
            <span className="lw-dot" />
            {t(team.eyebrow)}
          </div>
          <h1>{t(team.title)}</h1>
          <p>{t(team.lede)}</p>
        </div>
      </header>

      <section className="lwt-people">
        <div className="lw-wrap">
          <div className="lw-section-head">
            <span className="lw-kicker">{t(team.staffKicker)}</span>
            <h2 className="lw-h-title">{t(team.staffTitle)}</h2>
          </div>
          <div className="lw-card-grid">
            {staff.map((person) => (
              <div className="lw-person-card" key={person.name}>
                <div className="lw-person-img">
                  <img src={person.img} alt={person.name} />
                </div>
                <div className="lw-person-info">
                  <h3>{person.name}</h3>
                  <p>{person.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="lwt-people lwt-people-alt">
        <div className="lw-wrap">
          <div className="lw-section-head">
            <span className="lw-kicker">{t(team.juryKicker)}</span>
            <h2 className="lw-h-title">{t(team.juryTitle)}</h2>
          </div>

          <h3 className="lw-jury-edition-title">{t(team.jury2022Edition)}</h3>
          <div className="lw-card-grid">
            {jury.map((person) => (
              <div className="lw-person-card" key={person.name}>
                <div className="lw-person-img">
                  <img src={person.img} alt={person.name} />
                </div>
                <div className="lw-person-info">
                  <h3>{person.name}</h3>
                  <p>{t(team.juryMember)}</p>
                </div>
              </div>
            ))}
          </div>

          <h3 className="lw-jury-edition-title">{t(team.jury2025Edition)}</h3>
          <div className="lw-card-grid">
            {jury2025.map((person) => (
              <div className="lw-person-card" key={person.name}>
                <div className="lw-person-img">
                  <img src={person.img} alt={person.name} />
                </div>
                <div className="lw-person-info">
                  <h3>{person.name}</h3>
                  <p>{person.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <footer className="lw-footer">
        <div className="lw-wrap lw-foot-bottom">
          <span>{t(footer.est)}</span>
          <Link to="/">{t(footer.backHome)}</Link>
        </div>
      </footer>
    </div>
  );
};

export default OurTeam;
